{
  "menu": {
    "home": "Home",
    "customers": "Customers",
    "branches": "Branches",
    "viewEnquiries": "View Enquiries",
    "pendingOrders": "Pending Orders",
    "placedOrders": "Placed Orders",
    "cancelledOrders": "Cancelled Orders",
    "resourceCentre": "Resource Centre",
    "news": "News",
    "store": "{touch} Store",
    "knowledgeBase": "Knowledge Base",
    "createQuote": "Create Quote",
    "createOrder": "Create Order",
    "viewQuotes": "View Quotes",
    "viewOrders": "View Orders",
    "support": "Quick Support",
    "setup": {
      "text": "Setup",
      "account": "Account",
      "staff": "Staff",
      "productSettings": "Product Settings",
      "costsPrices": "Costs/Prices",
      "styling": "Styling",
      "delivery": "Delivery",
      "paymentGateway": "Payment Gateway",
      "retailOptionControl": "Retail Option Control",
      "brandedMode": {
        "text": "{brandedMode}"
      }
    }
  },
  "pages": {
    "dashboard": "Dashboard",
    "setup": "Setup",
    "account": "Account",
    "staff": "Staff",
    "styling": "Styling",
    "product-settings": "Product Settings",
    "selections": "Selections",
    "requote-markups": "Requote Markups",
    "alternate-sash-overlaps": "Alternate Sash Overlaps",
    "alternate-glass-clearance": "Alternate Glass Clearance",
    "costs-prices": "Costs & Prices",
    "pricing-setup": "Pricing Setup",
    "financial-categories": "Financial Categories",
    "discount-categories": "Discount Categories",
    "parts-list": "Parts List",
    "glass": "Glass",
    "panel": "Panel",
    "slab-glass-bands": "Slab Glass Bands",
    "slab": "Slab",
    "labour": "Labour",
    "cost-list": "Cost List",
    "price-list": "Price List",
    "product": "Product",
    "company": "Company",
    "products": "Products",
    "deployment": "Deployment",
    "delivery": "Delivery",
    "charges": "Charges",
    "lead-times": "Lead Times",
    "options": "Options",
    "retail-option-control": "Retail Option Control",
    "details": "Details",
    "settings": "Settings",
    "imagesAndText": "Images & Text",
    "emails": "Emails",
    "paperwork": "Paperwork",
    "payment-gateway": "Payment Gateway",
    "specifications": "Catalogue Specifications",
    "defaults": "Defaults",
    "product-specifications": "Specifications",
    "product-defaults": "Defaults",
    "availability": "Availability"
  },
  "labels": {
    "name": "Name",
    "company": "Company",
    "contactNumber": "Contact Number",
    "salesContact": "Sales Contact",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "phoneNumber": "Phone Number",
    "address": "Address",
    "address1": "Address Line 1",
    "address2": "Address Line 2",
    "city": "City",
    "state": "State/Province",
    "postcode": "Postcode",
    "country": "Country",
    "defaultTaxRate": "Default Tax Rate",
    "defaultContact": "Default Contact",
    "taxRate": "Tax Rates",
    "website": "Website",
    "admin": "Admin",
    "customerType": "Customer Type",
    "searchBranch": "Search Branch",
    "companyRegistrationNumber": "Company Registration Number",
    "vatRegistrationNumber": "VAT Registration Number",
    "currency": "Currency",
    "requoteMarkup": "Requote Markup",
    "license": "License",
    "status": "Status",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "live": "Live",
    "archived": "Archived",
    "yes": "Yes",
    "no": "No",
    "processingLevels": "Processing Levels",
    "departments": "Departments",
    "optional": "Optional",
    "profilePhoto": "Profile Photo",
    "adminUser": "Admin User",
    "noLogin": "No Login",
    "description": "Description",
    "value": "Value",
    "notes": "Notes",
    "accountCode": "Account Code",
    "accountEnabled": "Account Enabled",
    "title": "Title",
    "category": "Category",
    "listOrder": "List Order",
    "active": "Active",
    "product": "Product",
    "products": "Products",
    "image": "Image",
    "order": "Order",
    "type": "Type",
    "group": "Group",
    "optionHeadings": "Option Headings",
    "optionItems": "Option Items",
    "branch": "Branch",
    "all": "All",
    "emailAddress": "Email Address",
    "step": "Step",
    "index": "Index",
    "previewChanges": "Preview Changes",
    "none": "None",
    "code": "Code",
    "customer": "Customer",
    "quantity": "Quantity",
    "off": "Off",
    "on": "On",
    "pending": "Pending"
  },
  "validation": {
    "passwordsNoMatch": "Passwords do not match",
    "noResults": "No results found",
    "delete": "Are you sure you want to delete {item}?",
    "unSavedChanges": "There are unsaved changes",
    "unSavedChangesQuery": "You have unsaved changes. Are you sure you want to leave without saving?",
    "saveChanges": "Save changes?",
    "confirmSave": "Confirm Save",
    "invalidData": "Invalid Data",
    "widthMustDiffer": "Width minimum and maximum must differ",
    "heightMustDiffer": "Height minimum and maximum must differ",
    "cornerCostRequired": "At least one corner cost must have a value",
    "staff": {
      "resendActivation": "Must save user before resending activation",
      "activationEmailResent": "Activation Email Resent",
      "resendActivationEmail": "Resend Activation Email",
      "termsAndConditions": "You must accept the terms and conditions",
      "defaultContact": "There can only be one default ticket contact. This user will now be the only default contact for users without a bespoke contact set. Continue?",
      "archivedStaff": "At least one staff member must not be archived.",
      "branchUsersNonAdmin": "Branch users are non-admins"
    },
    "rules": {
      "required": "{field} is required",
      "requiredMultiple": "At least one {field} is blank",
      "email": "{field} must be a valid email address",
      "maxLength": "{field} must not exceed {max} characters",
      "minLength": "{field} must be at least {min} characters",
      "url": "{field} must be a valid URL",
      "numeric": "{field} must be a number",
      "numericMultiple": "At least one {field} is not a number",
      "wholeNumber": "{field} must be a whole number",
      "min": "{field} must be at least {min}",
      "minMultiple": "At least one {field} is below the minimum of {min}",
      "max": "{field} must not exceed {max}",
      "pattern": "{field} is in an invalid format"
    },
    "product": {
      "greaterThan": "<u>{corner}</u> must be <strong>greater than or equal</strong> to other corners",
      "lessThanOrEqualTo": "<u>{fieldKeyA}</u> must be <strong>less than or equal</strong> to <u>{fieldKeyB}</u>",
      "greaterThanOrEqualTo": "<u>{fieldKeyA}</u> must be <strong>greater than or equal</strong> to <u>{fieldKeyB}</u>",
      "atLeastOneEnabled": "You must leave at least 1 product enabled"
    },
    "leadCapture": {
      "confirmSaveText": "Changes made will be published to live instantly. Are you sure you want to save?"
    }
  },
  "buttons": {
    "save": "Save Changes",
    "cancel": "Cancel",
    "replace": "Replace",
    "remove": "Remove",
    "DragDrop": "Drag & drop",
    "browse": "Browse",
    "goBack": "Go Back",
    "continue": "Continue",
    "update": "Update",
    "add": "Add",
    "delete": "Delete",
    "confirm": "Confirm",
    "submit": "Submit",
    "import": "Import",
    "revert": "Revert",
    "undo": "Undo",
    "rename": "Rename",
    "reorder": "Reorder",
    "reset": "Reset",
    "selectAll": "Select All",
    "confirmAndSave": "Confirm & Save",
    "create": "Create",
    "readMore": "Read More",
    "sync": "Sync"
  },
  "global": {
    "branding": "By {brandName}",
    "cookie": {
      "title": "Cookie Notice",
      "text": "This website collects cookies to deliver better user experience, We collect cookies to analyse our website traffic and performance; we never collect any personal data unless agreed at point of collection and we will notify you in advance."
    },
    "search": "Search {item}...",
    "images": {
      "requiredFileType": "Required file type: {fileTypes}",
      "recommendedSize": "Recommended size: {width}px x {height}px.",
      "maxFileSize": "Max File Size: {mb}MB"
    }
  },
  "login": {
    "title": {
      "line1": "Welcome To"
    },
    "description": "Login here to manage {license} quotes, orders, products, news, resources and {retailType} enquiries.",
    "form": {
      "title": "Welcome back!",
      "description": "Continue to your dashboard",
      "inputs": {
        "username": "Username",
        "email": "Email",
        "password": "Password",
        "confirmPassword": "Confirm Password",
        "superuser": "Customer Email"
      },
      "toggle": {
        "superuser": "Login as Super User"
      },
      "forgotPassword": "Forgot your password? Click here!",
      "register": "Register for an Account",
      "cta": "Login"
    },
    "store": "{touch} Store"
  },
  "dashboard": {
    "kpi": {
      "daysAgo": "Last {days} Days",
      "ordersPlaced": "Orders Placed",
      "quotesCreated": "Quotes Created",
      "enquiries": "{retail} Enquiries",
      "generatedByYou": "generated by you"
    },
    "welcome": {
      "text": "Hi {name}...",
      "description": "Welcome to your {company} Admin",
      "addCustomer": "Add Customer",
      "allowMoreCustomers": "Allow more customers to quote & order.",
      "addStaff": "Add Staff",
      "allowMoreStaff": "Add more staff members to your team.",
      "links": {
        "help": {
          "text": "Help Guides",
          "description": "{touch} Support Documents"
        },
        "resources": {
          "text": "Resources",
          "description": "Brochure & Guides"
        }
      }
    },
    "enquiries": {
      "link": "View All",
      "table": {
        "date": "Date",
        "customer": "Customer",
        "postcode": "Postcode"
      },
      "assign": "Assign",
      "title": "Your Enquiries",
      "none": {
        "text": "No Enquiries Received",
        "description": "Any enquiries from {retail} will land here."
      },
      "dealer": {
        "upgrade": " Upgrade",
        "text": "Generate consumer enquiries to pass to your customers to facilitate.",
        "description": "To upgrade to {retail} contact the BM Group sales team on"
      },
      "leadCapture": {
        "title": "Generate Consumer Enquiries",
        "text": "{retail} allows you to generate your own enquiries on your website, social channels and in your showroom.",
        "subtext": "Includes Home Visualiser",
        "button": "Setup {retail}"
      }
    },
    "support": {
      "title": "Customer Support",
      "manageResources": "Manage Resources",
      "manageResourcesDescription": "Allow customers to download marketing collateral; Technical guides, brochures, images, photos & more",
      "manageNews": "Manage News",
      "manageNewsDescription": "Upload news that is viewable by customers in their Portal; Promote products, industry, and company news."
    },
    "summary": {
      "title": "Your Enquiries",
      "link": "View All",
      "table": {
        "date": "Date",
        "customer": "Customer",
        "postcode": "Postcode",
        "cost": "Cost"
      },
      "assign": "Assign",
      "brandedEnabled": {
        "text": "Once you have deployed {retail} any enquiries you generate will appear here.",
        "tips": "Tips on deploying to {retail}"
      },
      "brandedDisabled": {
        "text": "At the moment you have no enquiries.",
        "description": "Generate enquiries today with {retail}.",
        "button": "Start your Free Trial"
      },
      "dealer": {
        "text": "At the moment you have no enquiries.",
        "description": "Contact your Fabricator to become a preferred partner and gain access to FREE enquiries..."
      },
      "leadCapture": {
        "title": "Generate Consumer Enquiries",
        "text": "{retail} allows you to generate your own enquiries on your website, social channels and in your showroom.",
        "subtext": "Includes Home Visualiser",
        "button": "Setup {retail}"
      }
    },
    "news": {
      "title": "Latest News",
      "from": "from",
      "cta": "View All"
    },
    "hero": {
      "expiring": {
        "text": {
          "line1": "Your fabricator",
          "line2": "supported subscription",
          "line3": "for {touch} is...",
          "line4": "Expiring Soon"
        },
        "tag": "Act Now to Stay Online",
        "cta": {
          "text": {
            "expired": "Expired",
            "expiring": "Expiring"
          },
          "description": "Buy {brandedMode}"
        }
      },
      "active": {
        "text": {
          "line1": "Get the best from",
          "line2": "{brandedMode}",
          "list1": "How to generate enquiries",
          "list2": "Banners & button ideas",
          "list3": "Social media ideas",
          "list4": "Plus more..."
        },
        "cta": {
          "text": "{brandedMode} Tips",
          "description": "4 Tips on generating enquiries"
        }
      },
      "inactive": {
        "text": {
          "line1": "Don't Miss out!",
          "line2": "Generate enquiries with..",
          "line3": "{brandedMode}"
        },
        "cta": {
          "text": "Try {brandedMode}",
          "description": "Activate free features"
        }
      }
    },
    "checklist": {
      "label": {
        "setupChecklist": "{product} Setup Checklist"
      },
      "text": {
        "setupChecklist": "Click a section below to jump directly to it.",
        "step1": "1. Add you company details and logo ",
        "step2": "2. Add your team members",
        "step3": "3. Personalise your paperwork",
        "step4": "4. Choose how you want to price",
        "step4b": "At this point you are ready to start quoting",
        "step5": "5. Setup Lead Capture Designer",
        "step5b": "At this point you can generate leads on your website, social channels or show rooms."
      }
    },
    "knowledgeBase": {
      "title": "Knowledge Base",
      "store": "{touch} Store",
      "enquire": "Enquire Now",
      "hide": {
        "title": "Hide Article",
        "description": {
          "text": "Please visit the {0} to undo this change.",
          "link": "Account Page"
        },
        "cancel": "Cancel",
        "cta": "Hide Article"
      },
      "articles": {
        "0": {
          "title": "{0} Setup Checklist"
        },
        "1": {
          "title": "How to Buy {1}"
        },
        "2": {
          "title": "{1} Setup Guide"
        },
        "3": {
          "title": "Deploying {1}"
        },
        "4": {
          "title": "Increase Sales with {1}"
        },
        "5": {
          "title": "Consumer Website Theme"
        },
        "6": {
          "title": "Trade Website Theme"
        },
        "7": {
          "title": "Bespoke Website"
        },
        "8": {
          "title": "{2}"
        }
      }
    }
  },
  "delivery": {
    "titleAdd": "Add Address",
    "titleEdit": "Edit Address",
    "labels": {
      "addressSearch": "Address Search",
      "addressManual": "Address 1 (Manual mode - auto-complete deactivated)",
      "enterAddressManually": "Enter address manually",
      "address1": "Address 1",
      "address2": "Address 2",
      "address3": "Address 3",
      "town": "Town",
      "county": "County",
      "country": "Country",
      "postcode": "Postcode",
      "longitude": "Longitude",
      "latitude": "Latitude",
      "adjustCoordinates": "Adjust Coordinates",
      "primaryAddress": "Primary Address",
      "postCodeAreas": "Postcode Areas",
      "postCodeAreaList": "Postcode Area List",
      "postCodeAreaPlaceholder": "Add post code prefix...",
      "postCodeAreaMultiple": "Enter comma seperated list of postcode areas",
      "deliveryAddress": "Delivery Address",
      "deliveryDate": "Delivery Date",
      "deliveryCharge": "Delivery Charge",
      "deliveryType": "Delivery Type",
      "deliveryDays": "Delivery Days",
      "deliveryOption": "Delivery Option",
      "minimumOrderValue": "Minimum Order Value",
      "leadTime": "Lead Time",
      "day": "Day",
      "days": "Days",
      "onward": "Onward"
    },
    "table": {
      "headers": {
        "line1": "Line 1",
        "line2": "Line 2",
        "line3": "Line 3",
        "town": "Town",
        "county": "County",
        "country": "Country",
        "postcode": "Postcode",
        "primary": "Primary",
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday",
        "sun": "Sunday"
      }
    },
    "validation": {
      "latitudeLongitudeRequired": "Latitude & Longitude are required for geographical selection via enquiries."
    }
  },
  "processing": {
    "labels": {
      "refusalReason": "Refusal Reason"
    }
  },
  "setup": {
    "account": {
      "title": "Account",
      "labels": {
        "startDate": "Start Date",
        "endDate": "End Date",
        "code": "Code",
        "discountAmount": "Discount Amount",
        "usersPerAccount": "Users Per Account",
        "totalUses": "Total Uses",
        "dateRange": "Date Range"
      },
      "header": {
        "AccountCode": "Account Code"
      },
      "delivery": {
        "title": "Delivery Addresses & Days",
        "action": "Add Address"
      },
      "companyDetails": {
        "titleEdit": "Edit Company Details"
      },
      "financialDetails": {
        "titleEdit": "Edit Financial Details",
        "labels": {
          "applyTax": "Apply Tax",
          "applyTaxToRequotes": "Apply Tax to Requotes",
          "requoteTaxValue": "Requote Tax Value",
          "allowProductRequoteMarkups": "Allow Product Requote Markups",
          "linkedBranches": "Linked Branches",
          "taxValue": "Tax Value"
        }
      }
    },
    "staff": {
      "titleAdd": "Add Staff",
      "licenseLimit": "{active} out of {limit} licenses allocated"
    },
    "product": {
      "labels": {
        "sourceOverlaps": "Source Overlaps",
        "sourceClearances": "Source Clearances",
        "fixedGlass": "Fixed Glass",
        "sashGlass": "Sash Glass",
        "addGroup": "Add Group",
        "editGroup": "Edit Group",
        "addType": "Add Type",
        "editType": "Edit Type",
        "groups": "Groups",
        "types": "Types",
        "fittingCostPerProduct": "Fitting Cost / Product",
        "fittingCostPerChildProduct": "Fitting Cost / Child Product",
        "optionHeading": "Option Heading",
        "optionItem": "Option Item",
        "currentDefault": "Current Default",
        "mainDefault": "Main Default",
        "newDefault": "New Default",
        "noDefault": "No Default",
        "noOptionsAvailable": "No options available",
        "selectDefault": "Select a default",
        "subscriptionType": "Subscription Type",
        "availableToOrder": "Available to Order",
        "availableInLeadCapture": "Available in Lead Capture",
        "catalogue-products": "Catalogue Products"
      },
      "tooltips": {
        "sourceOverlaps": "Profiles with a source clearance of <b>{value}mm</b>",
        "sourceClearances": "Profiles with a source clearance of <b>{value}mm</b>"
      }
    },
    "costsPrices": {
      "labels": {
        "fittingCost": "Fitting Cost",
        "fittingMarkup": "Fitting Markup",
        "surveyCost": "Survey Cost",
        "supplyMarkup": "Supply Markup",
        "unitOfMeasure": "Unit of Measure",
        "cost": "Cost",
        "price": "Price",
        "listPrice": "List Price",
        "listCost": "List Cost",
        "markup": "Markup",
        "wastage": "Wastage",
        "override": "Override",
        "minimumAreaForCosting": "Minimum Area for Costing",
        "minimumAreaForPricing": "Minimum Area for Pricing",
        "nonRectangularPremium": "Non-Rectangular Premium",
        "minHeight": "Minimum Height",
        "maxHeight": "Maximum Height",
        "minWidth": "Minimum Width",
        "maxWidth": "Maximum Width",
        "width": "Width",
        "height": "Height",
        "Step": "Step",
        "baseFrameCost": "Base Frame Cost",
        "topLeftCost": "Top Left Cost",
        "topRightCost": "Top Right Cost",
        "bottomLeftCost": "Bottom Left Cost",
        "bottomRightCost": "Bottom Right Cost",
        "baseFramePrice": "Base Frame Price",
        "topLeftPrice": "Top Left Price",
        "topRightPrice": "Top Right Price",
        "bottomLeftPrice": "Bottom Left Price",
        "bottomRightPrice": "Bottom Right Price",
        "baseSashCost": "Base Sash Cost",
        "baseSashPrice": "Base Sash Price",
        "topLeft": "Top Left",
        "topRight": "Top Right",
        "bottomLeft": "Bottom Left",
        "bottomRight": "Bottom Right",
        "allCorners": "All Corners",
        "otherCorners": "Other Corners",
        "jointCornerSquareWeld": "Joint Corner Square Weld",
        "jointCornerSquareMech": "Joint Corner Square Mech",
        "jointCornerAngledWeld": "Joint Corner Angled Weld",
        "jointCornerAngledMech": "Joint Corner Angled Mech",
        "jointTSquareWeld": "Joint T Square Weld",
        "jointTSquareMech": "Joint T Square Mech",
        "jointTAngledWeld": "Joint T Angled Weld",
        "jointTAngledMech": "Joint T Angled Mech",
        "jointButtWeld": "Joint Butt Weld",
        "jointButtMech": "Joint Butt Mech",
        "jointCruciformWeld": "Joint Cruciform Weld",
        "jointCruciformMech": "Joint Cruciform Mech",
        "jointCillWeld": "Joint Cill Weld",
        "jointCillMech": "Joint Cill Mech",
        "cornerJointSquare": "Corner Joint Square",
        "cornerJointAngled": "Corner Joint Angled",
        "tJointAngled": "T Joint Angled",
        "tJointSquare": "T Joint Square",
        "buttJoint": "Butt Joint",
        "cruciformJoint": "Cruciform Joint",
        "cillJoint": "Cill Joint",
        "opener": "Opener",
        "fixed": "Fixed",
        "glazing": "Glazing",
        "beading": "Beading",
        "ancillary": "Ancillary",
        "reinforcing": "Reinforcing",
        "band": "Band",
        "sashOverlap": "Sash Overlap",
        "weight": "Weight",
        "groupName": "Group Name",
        "quickPricing": "Quick Pricing",
        "advancedPricing": "Advanced Pricing",
        "noMarkupToPrice": "No Mark Up To Price",
        "financialCategory": "Financial Category",
        "discountCategory": "Discount Category",
        "profileColour": "Profile Colour",
        "per": "Per",
        "warningActivePricingMethods": "Warning - Active Pricing Methods",
        "customerPrices": "Customer Prices",
        "partName": "Part Name",
        "itemColour": "Item Colour",
        "itemCode": "Item Code",
        "globalPrice": "Global Price",
        "customerPrice": "Customer Price",
        "basePrice": "Base Price",
        "baseCost": "Base Cost",
        "priceFromCostsPlusMarkup": "Price From Cost Plus Mark Up",
        "general": "General",
        "frame": "Frame",
        "sash": "Sash",
        "colours": "Colours",
        "hardware": "Hardware",
        "profiles": "Profiles",
        "simulateCostMatrix": "Simulate Cost Matrix",
        "simulatePriceMatrix": "Simulate Price Matrix",
        "costMatrix": "Cost Matrix",
        "priceMatrix": "Price Matrix",
        "possibleCombinedPricing": "Possible Combined Pricing",
        "types": "Types",
        "patterns": "Patterns",
        "spacerBars": "Spacer Bars",
        "decorations": "Decorations",
        "gasFill": "Gas Fill",
        "fanHoles": "Fan Holes",
        "designs": "Designs",
        "backingGlass": "Backing Glass",
        "numerals": "Numerals",
        "knockers": "Knockers",
        "letterplates": "Letterplates",
        "spyholes": "Spyholes",
        "doorDesigns": "Door Designs",
        "doorGlass": "Door Glass",
        "doorColour": "Door Colour",
        "decorativeGlassDesign": "Decorative Glass Design",
        "items": "Items",
        "grids": "Grids",
        "lists": "Lists",
        "financialGroups": "Financial Groups",
        "addNewGroup": "Add New Group",
        "upliftSelected": "Uplift Selected",
        "modifySelected": "Modify Selected",
        "upliftCost": "Uplift Cost",
        "upliftPrice": "Uplift Price",
        "wholeNumber": "Whole Number",
        "uplift": "Uplift",
        "netPrice": "Net",
        "copyTo": "Copy To",
        "copiedFrom": "Copied From",
        "copyProductTo": "Copy ${productName} to...",
        "weld": "Weld",
        "mech": "Mech",
        "angled": "Angled",
        "units": "Units",
        "joint": "Joint",
        "aperture": "Aperture",
        "piece": "Piece",
        "rates": "Rates",
        "part": "Part",
        "perOption": "Per option",
        "perPart": "Per part"
      },
      "text": {
        "setupPricing": "How would you like to set up your pricing?",
        "setupPricingDescription": "Select between quick pricing for simple jobs or advanced pricing for accurate itemised pricing.",
        "quickPricing": "Once you create a quote or convert an enquiry into one, simply open the quote details page and click 'Adjust Price'. This lets you set a job price without completing the full advanced pricing setup.",
        "quickSetupImage1Alt": "Pricing breakdown with button showing how to adjust price",
        "quickSetupImage2Alt": "Pop up after clicking adjust price showing field to enter new price",
        "pricingOverlapWarning": "Pricing can overlap when values are configured in both Parts List <b>(per part)</b> and in Product, Glass, Panel or Slab <b>(per option)</b>. To keep totals accurate and predictable, apply each pricing rule in one place only.",
        "strategy1Title": "Strategy 1: Cost + Markup",
        "strategy1Description": "Build prices automatically from your costs and markup percentages.",
        "strategy1Step1Prefix": "Set up",
        "strategy1Step1LinkFinancialCategories": "financial categories",
        "strategy1Step1Suffix": "and markup percentages",
        "strategy1Step2PerOptionPrefix": "Add costs per option and assign financial categories in",
        "strategy1Step2PerOptionSuffix": "pages",
        "strategy1Step2PerPartPrefix": "Add costs and assign financial categories per part in",
        "strategy1Step2PerPartLink": "parts list",
        "strategy1Step3Prefix": "Add",
        "strategy1Step3LinkLabour": "labour",
        "strategy1Step3Suffix": "costs and assign financial categories",
        "strategy2Title": "Strategy 2: Direct Pricing",
        "strategy2Description": "Enter fixed prices yourself with no markup calculation.",
        "strategy2Step1PerOptionPrefix": "Add prices per option in",
        "strategy2Step1PerOptionSuffix": "pages",
        "strategy2Step1PerPartPrefix": "Add prices per part in",
        "strategy2Step1PerPartLink": "parts list",
        "strategy2Step2Prefix": "Add",
        "strategy2Step2LinkLabour": "labour",
        "strategy2Step2Suffix": "prices",
        "advancedPricing": {
          "line1": "Advanced Pricing gives you full control over your job costing. It also allows you to design a product and live-price it in real time. Any enquiries generated through the Lead Capture Designer will be automatically priced once converted to a quote.",
          "line2": "Once you setup advanced pricing it can still be overidden with adjust price feature used for quick pricing.",
          "line3": "To complete your Advanced Pricing setup, you'll need to configure:"
        },
        "startPricingSetup": "See tabs above to start your pricing setup",
        "costMarkupTooltip": "Value entered will affect Cost + Markup pricing methods only",
        "wastageTooltip": "Value entered will affect wastage calculated on all bill of material items",
        "selectMultipleBy": "Select multiple by",
        "warningActivePricingMethods": {
          "line1": "If you have active pricing methods within the tabs above, adding prices here won’t replace existing pricing. Methods will combine. Update this section and remove/disable other methods to avoid incorrect totals.",
          "line2": "This section adds another pricing method. If you already have pricing configured elsewhere (e.g., Cost+Markup (Parts List) or Grids (Cost List/Price List), those prices will not be replaced - they will work in conjunction and may stack. To use this method as the single source of truth, update here first and then manually remove/disable the other methods. Otherwise, incorrect prices may be shown in quotes and orders."
        },
        "possibleCombinedPricing": "If you have other pricing methods enabled. Saving here will not replace them and may change final prices due to combined methods.",
        "moveFinancialItemsWarning": "Please move all financial items out of this group before you delete it.",
        "moveFinancialItemsConfirmation": " Are you sure you want to move {from} to {to}?"
      }
    },
    "retail": {
      "labels": {
        "alias": "Alias",
        "iframeRedirect": "Iframe Redirect",
        "metaTitle": "Meta Title",
        "hiddenOptions": "Hidden Options",
        "visibleOptions": "Visible Options",
        "optionItems": "Option Items",
        "overrideDefaultOrder": "Override Default Order",
        "selectedHeading": "Selected Heading"
      },
      "tooltips": {
        "hiddenOptions": "Add hidden options to the Retail Designer",
        "visibleOptions": "Customise visible options for the Retail Designer",
        "optionItems": "Enable or disable individual options for the Retail Designer"
      },
      "validation": {
        "customOrderActive": "Custom order is configured and <strong>is active</strong>. Toggle above to unapply changes.",
        "customOrderInactive": "Custom order is configured but <strong>not active</strong>. Toggle above to apply changes.",
        "applyCustomOrder": "This will apply your custom option order in the Retail Designer.",
        "revertCustomOrder": "This will revert to the default option order in the Retail Designer.",
        "overrideDefaultOrder": "Override Default Order",
        "revertDefaultOrder": "Revert to Default Order",
        "unsavedChanges": "Please save or discard your changes before switching sort order"
      },
      "company": {
        "labels": {
          "enquiryOverdueLimit": "Time Limit for Assigned Enquiries",
          "logo": "Logo",
          "yourAddress": "Your Address",
          "newAddress": "New Address",
          "selectAddress": "Select Address",
          "requestMeasurements": "Request Measurements",
          "showDesignNames": "Show Design Names",
          "thankYouPageRedirect": "Thank You Page Redirect"
        },
        "text": {
          "contractConfirmation": "All your quote and order confirmations will be sent here.",
          "rejectedEnquiries": "We'll email this address with details of any rejected enquiries.",
          "enquiryOverdueLimit": "When you assign a {setup} enquire how long will the customer have to action the enquiry. Add a number of hours. If not actioned in this time the enquiry will be available to assign to another customer.",
          "paperwork": "This will be displayed on your paperwork that will be sent to a customer.",
          "requestMeasurements": " Would you like to request measurements from your customers via the {setup} Designer? If Yes, this question will appear on the intro screen.",
          "showDesignNames": "Choose between Design A or Design B when a customer chooses a product type.",
          "googleAnalytics": {
            "compatibleWith": "Not compatible with deployment 2 (iFrame deployment). Please select deployment 1.",
            "setup": "Setup analytics to measure traffic & conversions in {setup}.",
            "step1": "Provide the gtag code embedded on your website.",
            "step2": {
              "header": "Setup Cross-domain Measurements",
              "text": "Allows activity to be accurately attributed to a single user as they cross domains",
              "part1": "Go to the Google Analytics home page linked to the gtag above.",
              "part2": "In Admin, under Data collection and modification, click Data streams",
              "part3": "Click Web, then click a web data stream",
              "part4": "In the web stream details, click Configure tag settings (at the bottom)",
              "part5": "In the Settings section, click Configure your domains",
              "part6": "Click Add condition under Include domains and set match type to Exactly matches",
              "part7": "Enter the domain for your website, e.g. example.com (without https)",
              "part8": "Repeat step 6 and enter the domain for the designer which is quotila.com"
            },
            "step3": {
              "header": "Verify Cross-domain Measurements is Working",
              "part1": "Open a page of your site that contains a link to {setup} Mode.",
              "part2": "Click the link and verify that the URL in the destination domain contains the linker parameter _gl"
            },
            "step4": {
              "header": "Verify Conversion Data is Working",
              "text": "A conversion event will be named enquiry-conversion",
              "part1": "Submit an enquiry",
              "part2": "Go to Google Analytics Realtime report. You should see the event name with at least one conversion next to the name in the card"
            }
          },
          "thankYouPageRedirect": "Redirect customers to a custom url after submitting enquiry form in {setup} Mode."
        },
        "validation": {
          "yourAddress": "You have no saved addresses",
          "invalidTag": "Invalid Google Tag",
          "invalidTagHtml": "Please do not enter <strong>G-</strong> as part of the code."
        },
        "buttons": {
          "editAddress": "Edit Address",
          "refreshRequired": "Refresh Required"
        }
      },
      "products": {
        "labels": {
          "showToConsumers": "Show to Consumers",
          "showOn": "Show on {setup}"
        },
        "text": "Select which products you sell from the list below, these will then be shown on your {setup} designer"
      },
      "styling": {
        "labels": {
          "landingPageBackground": "{setup} Landing Page Background",
          "landingPageText": "{setup} Landing Page Text",
          "landingPageTitle": "Landing Page Title",
          "landingPageIntro": "Landing Page Intro",
          "landingPageBodyText": "Landing Page Body Text",
          "virtualHomeBanner": "Virtual Home Banner",
          "virtualHomeBackground": "Virtual Home Background",
          "thankYouPageBackground": "Thank You Page Background",
          "thankYouPageText": "{setup} Thank You Page Text",
          "thankYouPageTitle": "Thank You Page Title",
          "thankYouPageIntro": "Thank You Page Intro",
          "thankYouPageBody": "Thank You Page Body Text",
          "customerEmail": "Customer Email Confirmation of New {setup} Enquiry",
          "emailSubject": "Email Subject",
          "emailBody": "Email Body",
          "consumerEmail": "Consumer email confirmation of new {setup} being assigned to your designated customer",
          "customText": "Custom Text",
          "enquiryEmailHeaderImage": "Enquiry Email Header Image",
          "enquiryPdfImage1": "Enquiry PDF image 1",
          "enquiryPdfImage2": "Enquiry PDF image 2",
          "enquiryPdfSummaryFooter": "Enquiry PDF Summary Footer",
          "FooterTitle": "Footer Title",
          "FooterText": "Footer Text"
        },
        "text": {
          "instruction": "Edit images and text to personalise {touch} for your business. You can edit various areas including; {setup} intro and enquiry screen, VirtualHome, pdfs and email correspondence to your customers.",
          "landingPageBackground": {
            "location": "Location: {setup} designer introduction page {setup}",
            "purpose": "Purpose: Personalise the landing page for your customers who visit {setup}"
          },
          "landingPageTitle": "This will be displayed on the {setup} designer page as the heading on the landing page.",
          "landingPageIntro": "This will be displayed on the {setup} designer page as the sub-heading on the landing page.",
          "landingPageBodyText": "This will be displayed on the {setup} designer page as the welcome text on the landing page.",
          "virtualHomeBanner": {
            "location": "Location: Basket Page",
            "purpose": "Purpose: To launch the Virtual Home feature"
          },
          "virtualHomeBackground": {
            "location": "Location: Virtual Home",
            "purpose": "Purpose: Personalise the background of the Virtual Home feature"
          },
          "thankYouPageBackground": {
            "location": "Location: {setup} Thank You Page",
            "purpose": "Purpose: Personalise the background of the {setup} Thank You Page"
          },
          "thankYouPageText": "This will be displayed on the {setup} designer thank you page as the heading on the landing page.",
          "thankYouPageIntro": "This will be displayed on the {setup} designer thank you page as the sub-heading on the landing page.",
          "thankYouPageBody": "This will be displayed on the {setup} designer thank you page as the welcome text on the landing page.",
          "customerEmailRecieved": "This is the email that will be sent to your customer to confirm that you have received their enquiry",
          "customerEmailAssignment": "This is the email that will be sent to your customer to confirm when they have been assigned a {setup} enquiry within their portal.",
          "consumerEmail": "This is the email that will be sent to the consumer to confirm which customer their enquiry has beenassigned to.",
          "enquiryEmailHeaderImage": {
            "location": "Location: The Header of the email receipt the user receives after making an enquiry.",
            "purpose": "Purpose: Personalise your paperwork with a photo displaying your product"
          },
          "enquiryPdfImage1": {
            "location": "Location: Intro page of the pdf emailed to the homeowner",
            "purpose": "Purpose: Personalise your paperwork with a photo displaying your product"
          },
          "enquiryPdfImage2": {
            "location": "Location: Outro page of the pdf emailed to the homeowner",
            "purpose": "Purpose: Personalise your paperwork with a photo displaying your product"
          },
          "enquiryPdfSummaryFooter": "The last page of the enquiry PDF, at the bottom of the summary section"
        },
        "buttons": {
          "manageStyling": "Manage Styling"
        }
      },
      "deployment": {
        "labels": {
          "deploy": "Deploy",
          "howToDeploy": "How to Deploy {setup}",
          "alias": "Alias"
        },
        "tooltips": {
          "deploy": "Click here for instructions on how to deploy {setup} to your website.",
          "alias": "Personalise the URL/website address for your {setup}. This is usually your company name."
        },
        "text": {
          "instruction": "Once you have completed the steps above, please click here for instructions on how to {setup}.",
          "subHeader": "How to deploy",
          "option1": {
            "title": "Option 1 - deploy in new window",
            "step1": "1) Click the 'Copy URL' button below.",
            "step2": "2) Add this link onto your website. We recommend linking this up to a button or banner. You can also add a link to the navigation of your website.",
            "step3": "3) Once the links have been added, your {setup} will now be live on your website and any updates you make to your settings will be automatically applied to your live {setup}.",
            "tip": "Tip: This link can also be posted directly to social media to generate further enquiries",
            "recommended": "Recommended"
          },
          "option2": {
            "title": "Option 2 - deploy in iframe",
            "step1": "1) Click the 'Copy iFrame' button below.",
            "step2": "2) Place the code snippet within a container where you want it to appear on your website.",
            "notRecommended": "Not recommended with Google Analytics Integration"
          },
          "gpdr": "Please upload your GDPR documents, you will then be able to deploy your designer."
        },
        "buttons": {
          "copyURL": "Copy URL",
          "copyIframe": "Copy Iframe"
        }
      },
      "knowledgeBase": {
        "labels": {
          "knowledgeBase": "Knowledge Base"
        },
        "text": "How to videos and guides.",
        "links": {
          "video1": "How to Setup {setup}",
          "video2": "How to Purchase {setup}",
          "video3": "How to use the Virtual Home Feature"
        }
      }
    },
    "styling": {
      "labels": {
        "requoteEmail": "{label} Emails",
        "emailSubject": "Email Subject",
        "emailBodyText": "Email Body Text",
        "quotePDFFirstPageImage": "Quote PDF First Page Image",
        "quotePDFLastPageImage": "Quote PDF Last Page Image",
        "quotation": "Quotation",
        "requote": "Re-quote",
        "metaTitle": "Meta Title",
        "primaryLoginImage": "Primary Login Image",
        "loginPageBackgroundImage": "Login Page Background Image",
        "portalLoginPageText": "Portal Login Page Text",
        "loginHeader": "Login Header",
        "loginSubHeader": "Login Sub Header",
        "loginBodyText": "Login Body Text"
      },
      "tooltip": {
        "emailAddress": "This is the email address where your {label} will be sent from.",
        "emailSubject": "Personalise the subject line for {label} emails that are sent to consumers.",
        "emailBodyText": "Personalise the message in your email, this could be a nice welcoming message or terms and conditions of the {label}.",
        "quotePDFFirstPageImage": "This will be displayed on the first page of the quote PDF.",
        "quotePDFLastPageImage": "This will be displayed on the last page of the quote PDF.",
        "metaTitle": "Meta tags are used to provide additional information about a page to search engines and are displayed within the tab title.",
        "primaryLoginImage": "This is the primary image that is displayed on your {touch} Portal login page where your customers will login.",
        "loginPageBackgroundImage": "This is the background image that is displayed on your {touch} Portal login page where your customers will login.",
        "portalLoginPageText": "This is the text displayed on your {touch} Portal login page where your customers will login.",
        "loginHeader": "This will be displayed on the Portal login page as the heading text.",
        "loginSubHeader": "This will be displayed on the Portal login page as the sub-heading text.",
        "loginBodyText": "This will be displayed on the Portal login page as welcome text underneath the headers."
      }
    },
    "retailOptionsControl": {
      "tooltips": {
        "productsFilter": {
          "line1": "Filter to focus on options for a specific product.",
          "line2": "Note: Filtering only changes what is highlighted here. It does not change the saved option order."
        }
      }
    }
  }
}
